import React from "react";
import { Container } from "reactstrap";
import "../../styles/privacypolicy.css";

const PrivacyPolicy = () => {
  return (
    <Container className="py-5 privacy-policy">
      <h1>Chính sách bảo mật thông tin</h1>
      <p><strong>1. Mục đích thu thập thông tin:</strong> Thu thập thông tin cá nhân (Họ tên, SĐT) để hỗ trợ tư vấn và giao hàng.</p>
      <p><strong>2. Phạm vi sử dụng:</strong> Thông tin chỉ được sử dụng nội bộ để cung cấp dịch vụ của Mekong Zone.</p>
      <p><strong>3. Cam kết:</strong> Chúng tôi cam kết không chia sẻ thông tin cho bên thứ ba, trừ khi có yêu cầu từ cơ quan pháp luật.</p>
    </Container>
  );
};

export default PrivacyPolicy;